import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import debug from 'debug';
import useSWR from 'swr';
import {LoadingSpinner, RowGrid, Tile, Column, Icon} from '../../shared';
import styled from 'styled-components/macro';
import {Featured} from '../components/insights';
import Insight from '../components/insights/Insight';
import history from '../../history';
import {getBackPath} from '../shared/utils/dashboardUtils';

const log = debug('circleblack:investor:pages:Insights');

const _Spinner = styled.div`
  margin: 100px 0 0 0;
`;

const Insights = ({session}) => {
  log('rendering');
  const {data: articles} = useSWR('/documents/?type=Article&sort=-distributionDate&limit=4');

  const backPath = getBackPath();

  const createInsight = (article, width) => (
    <Insight
      key={article.id}
      article={article}
      width={width}
      height={'fill'}
      fontSize={'12px'}
    />
  );

  if (!session || !articles?.length) {
    return <_Spinner><LoadingSpinner/></_Spinner>;
  }

  let featuredArticles;
  let gridArticles = false;

  if (articles.length <= 3) {
    featuredArticles = articles;
  } else {
    featuredArticles = articles.slice(0, 3);
    gridArticles = true;
  }
  return (
    <Tile margin={'10px'}
          title={'INSIGHTS'}
          icon={<Icon svg={'arrowCircle'}
                      rotate={'180deg'}
                      action={() => history.push(backPath)}/>}>
      <Column showDividers={false}>
        <Featured
              showHeading={featuredArticles.length > 2}
              articles={featuredArticles}
              height={'fill'}
        />
        {gridArticles && <RowGrid
          excludedItems={featuredArticles}
          excludedValueName={'id'}
          itemLimit={25}
          dataUrl={'/documents/?type=Article'}
          sortBy={'distributionDate'}
          sortAscending={false}
          createItem={createInsight}
          search={{
            searchOptions: [{title: 'Articles', name: 'title'}],
            noSearchResultsText: 'No articles found...',
          }}
        />}
      </Column>
    </Tile>
  );
};

const mapStateToProps = state => ({
  session: state.session,
});

export default connect(mapStateToProps, null)(Insights);

Insights.propTypes = {
  session: PropTypes.object.isRequired,
};
